import { render, staticRenderFns } from "./ShortcutGrid.vue?vue&type=template&id=4a5eaa84&scoped=true&"
import script from "./ShortcutGrid.vue?vue&type=script&lang=js&"
export * from "./ShortcutGrid.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutGrid.vue?vue&type=style&index=0&id=4a5eaa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5eaa84",
  null
  
)

export default component.exports